import React from 'react';
import ModalFormComponent from '../Modal/ModalFormComponent';
import PropTypes from 'prop-types';
import './style.css';
import VerifyAccountForm from "../../forms/VerifyAccountForm";

const ModalVerifyAccountComponent = ({ onHide }) => {

    return (
      <ModalFormComponent title="Verify your account"
                          id="verifyAccount"
                          visibility="byModalId"
                          icon="person"
      >
        <VerifyAccountForm onClose={onHide}/>
      </ModalFormComponent>
    )
};

ModalVerifyAccountComponent.propTypes = {
    name: PropTypes.object,
    onHide: PropTypes.func,
};

export default ModalVerifyAccountComponent;

